var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-link"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":_vm.alt}}),_c('a',{attrs:{"href":_vm.url,"title":_vm.title},on:{"click":function($event){return _vm.$emit('open')}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }